import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SessionRepository } from '@domain/session/session.repository';
import { Session } from '@domain/session/session';
import { SessionResponseDto } from '../dtos/session/session.response.dto';
import { SessionMapper } from '../mappers/session.mapper';

@Injectable()
export class SessionHttpRepository extends SessionRepository {
  private readonly baseUrl = `${environment.apiUrl}/session`;

  constructor(private readonly http: HttpClient) { super(); }

  getAll(): Observable<Session[]> {
    return this.http.get<SessionResponseDto[]>(this.baseUrl).pipe(
      map(dtos => dtos.map(dto => SessionMapper.fromDto(dto)))
    );
  }

  create(session: Session): Observable<Session> {
    return this.http.post<SessionResponseDto>(this.baseUrl, SessionMapper.toRequestDto(session)).pipe(
      map(dto => SessionMapper.fromDto(dto))
    );
  }

  update(session: Session): Observable<Session> {
    return this.http.put<SessionResponseDto>(`${this.baseUrl}/${session.id}`, SessionMapper.toRequestDto(session)).pipe(
      map(dto => SessionMapper.fromDto(dto))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  activate(id: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}/activate`, null);
  }

  exportCsv(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/export/csv`, { responseType: 'blob' });
  }

  exportExcel(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/export/excel`, { responseType: 'blob' });
  }
}
